import { $GQL } from '@GQL';

export async function compileAlgoBiddingVectors(params: { campaign_id: string;  conversion_date: string}) {
    const mutation = `
        mutation CompileAlgoBiddingVectors($params: JSONObject!) {
			compileAlgoBiddingVectors(params: $params) {
			    id
            }
        }
    `;

    const result = await $GQL.request(mutation, { params });
    return result.compileAlgoBiddingVectors;
}
